import React from 'react';
import { styled } from 'styled-components';

import type { IconFileTypeProps } from '../types.ts';

export const Component = styled.svg`
  min-width: ${({ width }) => `${width}px`};
`;

interface BaseComponentProps extends IconFileTypeProps {
  iconRender: () => React.ReactNode;
  ref: React.ForwardedRef<SVGSVGElement | null>;
  viewBox?: string;
}

export const FileTypeBaseComponent = React.memo(function FileTypeBaseComponent({
  className,
  onClick,
  dataTestId,
  ref,
  iconRender,
  viewBox = '0 0 30 36',
}: BaseComponentProps) {
  return (
    <Component
      className={className}
      onClick={onClick}
      ref={ref}
      width={30}
      height={36}
      viewBox={viewBox}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}>
      {iconRender()}
    </Component>
  );
});
